/* =====================================================================
   Aude Pluie — quiz analyse d'eau.
   <ap-quiz> : code postal -> département -> dureté médiane (°f) lue dans
   la table éditable de la section -> niveau calculé sur l'échelle Aude
   Pluie (<8 très douce · 8-15 douce · 15-30 moyenne · 30-40 dure · >40
   très dure), puis révèle le formulaire de capture email.

   Les données sont des MÉDIANES DÉPARTEMENTALES (SISE-Eaux) : la dureté
   varie d'une commune à l'autre, les textes le disent explicitement.

   Un bloc « zone » qui couvre le département reste prioritaire sur le
   verdict générique du niveau : c'est la surcouche rédactionnelle.
   ===================================================================== */
(function () {
  'use strict';
  if (customElements.get('ap-quiz')) return;

  var LEVELS = [
    { max: 8, key: 'tres-douce', label: 'très douce' },
    { max: 15, key: 'douce', label: 'douce' },
    { max: 30, key: 'moyenne', label: 'moyenne' },
    { max: 40, key: 'dure', label: 'dure' },
    { max: Infinity, key: 'tres-dure', label: 'très dure' }
  ];

  function levelFor(v) {
    for (var i = 0; i < LEVELS.length; i++) {
      if (v < LEVELS[i].max) return LEVELS[i];
    }
    return LEVELS[LEVELS.length - 1];
  }

  /* Corse : tous les codes postaux commencent par 20, mais la Corse-du-Sud
     (2A) et la Haute-Corse (2B) ont des duretés très différentes.
     200xx/201xx -> 2A (Ajaccio 20000) ; 202xx à 206xx -> 2B (Bastia 20200). */
  function deptFor(cp) {
    if (cp.slice(0, 2) !== '20') return cp.slice(0, 2);
    var c3 = cp.slice(0, 3);
    return c3 === '200' || c3 === '201' ? '2A' : '2B';
  }

  function parseTable(raw) {
    var out = {};
    (raw || '').split(/[\n,;]+/).forEach(function (pair) {
      var m = pair.trim().match(/^(\d{2}|2[AB])\s*=\s*(\d+(?:[.,]\d+)?)$/i);
      if (m) out[m[1].toUpperCase()] = parseFloat(m[2].replace(',', '.'));
    });
    return out;
  }

  function fmt(v) {
    return v.toFixed(1).replace('.', ',');
  }

  function readJSON(el) {
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  customElements.define(
    'ap-quiz',
    class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-ap-quiz-input]');
        this.btn = this.querySelector('[data-ap-quiz-go]');
        this.result = this.querySelector('[data-ap-quiz-result]');
        this.verdictEl = this.querySelector('[data-ap-quiz-verdict]');
        this.zoneEl = this.querySelector('[data-ap-quiz-zone]');
        this.tagField = this.querySelector('[data-ap-quiz-tag]');
        this.captureEl = this.querySelector('[data-ap-quiz-capture]');
        this.alreadyEl = this.querySelector('[data-ap-quiz-already]');
        this.okEl = this.querySelector('[data-ap-quiz-ok]');
        this.fieldsEl = this.querySelector('[data-ap-quiz-fields]');
        this.formEl = this.querySelector('.ap-quiz__emailform');

        /* Marqueur posé au submit DE CE formulaire — pas au clic : l'événement submit
           couvre aussi la validation par Entrée, et ne part que si la validation HTML5
           du champ email est passée. C'est la seule preuve qu'une soumission vient du
           quiz et non de l'exit-intent, qui partage le même form_type. */
        if (this.formEl) {
          this.formEl.addEventListener('submit', function () {
            try { sessionStorage.setItem('ap_quiz_pending', '1'); } catch (e) {}
          });
        }

        this.zones = readJSON(this.querySelector('[data-ap-quiz-zones]')) || [];
        if (!Array.isArray(this.zones)) this.zones = [];
        this.verdicts = readJSON(this.querySelector('[data-ap-quiz-verdicts]'));
        var tableEl = this.querySelector('[data-ap-quiz-table]');
        this.table = parseTable(tableEl ? tableEl.textContent : '');
        this.fallback = this.dataset.fallback || '';
        this.zoneTpl = this.dataset.zoneLabel || 'Département {dep} · {value} °f';

        if (this.btn) this.btn.addEventListener('click', () => this.run());
        if (this.input) {
          this.input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') { e.preventDefault(); this.run(); }
          });
        }

        this.syncSubmitted();
      }

      /* Anti-cumul de tags : une visiteuse qui refaisait le quiz et se réinscrivait
         accumulait des tags contradictoires (cp-75001 + cp-62180, eau-moyenne +
         eau-dure) sur la même fiche client.

         Le drapeau ne peut PAS se déduire de la variable Liquid de succès : le quiz et
         l'exit-intent partagent form_type=customer, donc Shopify rend les deux blocs en
         succès après l'une OU l'autre inscription. Une inscription par l'exit-intent
         faisait ainsi disparaître le bloc du quiz à tort.

         La preuve retenue est côté client et propre à ce formulaire : un marqueur de
         session posé à son submit, consommé au chargement suivant. Il n'est converti en
         drapeau durable que s'il est présent ; sinon rien n'est touché.

         Le marqueur est retiré à chaque lecture : il ne vaut que pour le retour de page
         qui suit immédiatement la soumission, et ne peut pas être rejoué plus tard. Si le
         stockage est indisponible (navigation privée), les accès jettent, tout reste à
         false, et le parcours est celui d'une première visiteuse. */
      syncSubmitted() {
        var KEY = 'ap_quiz_submitted';
        var PENDING = 'ap_quiz_pending';
        var pending = false;
        try {
          pending = !!sessionStorage.getItem(PENDING);
          sessionStorage.removeItem(PENDING);
        } catch (e) { pending = false; }

        /* Retour immédiat d'une soumission du quiz : on grave le drapeau et on montre le
           message de succès à la place des champs. */
        if (pending) {
          try { localStorage.setItem(KEY, new Date().toISOString()); } catch (e) {}
          if (this.fieldsEl) this.fieldsEl.hidden = true;
          if (this.okEl) this.okEl.hidden = false;
          return;
        }

        var done = false;
        try { done = !!localStorage.getItem(KEY); } catch (e) { done = false; }
        if (!done) return;
        if (this.captureEl) this.captureEl.hidden = true;
        if (this.alreadyEl) this.alreadyEl.hidden = false;
      }

      run() {
        var cp = (this.input.value || '').replace(/\s/g, '');
        if (!/^\d{5}$/.test(cp)) {
          this.input.setAttribute('aria-invalid', 'true');
          this.input.focus();
          return;
        }
        this.input.removeAttribute('aria-invalid');

        var dep = deptFor(cp);
        var value = Object.prototype.hasOwnProperty.call(this.table, dep) ? this.table[dep] : null;

        var levelKey = 'unknown';
        var zoneText = '';
        var verdict = this.fallback;

        if (value !== null) {
          var lv = levelFor(value);
          levelKey = lv.key;
          zoneText = this.zoneTpl
            .replace('{dep}', dep)
            .replace('{value}', fmt(value))
            .replace('{level}', lv.label);
          verdict = this.verdicts[lv.key] || this.fallback;

          /* Surcouche : un bloc « zone » qui couvre ce département (ou ce code
             postal complet) reprend la main sur le texte affiché. */
          for (var i = 0; i < this.zones.length; i++) {
            var prefixes = (this.zones[i].prefixes || '').split(/[\s,;]+/);
            if (prefixes.indexOf(dep) !== -1 || prefixes.indexOf(cp) !== -1) {
              if (this.zones[i].verdict) verdict = this.zones[i].verdict;
              if (this.zones[i].label) zoneText = this.zones[i].label + ' · ' + fmt(value) + ' °f';
              break;
            }
          }
        }

        this.result.dataset.level = levelKey;
        this.result.hidden = false;
        if (this.zoneEl) this.zoneEl.textContent = zoneText;
        if (this.verdictEl) this.verdictEl.textContent = verdict;
        if (this.tagField) this.tagField.value = 'quiz-eau, cp-' + cp + ', eau-' + levelKey;
        this.result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  );
})();
